module.exports = __webpack_public_path__ + "static/media/wd_page_area03_img_cn.65e2cf6d.png";